<!--
 * @Description  : 项目结构左侧列表
 * @Author       : 钱磊
 * @Date         : 2023-04-06 09:36:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-26 16:45:59
 * @FilePath     : \dx_execute_admin\src\views\business-setting\structure-type\components\left_structure.vue
-->
<template>
	<div class="h100">
		<div class="w-table-layout have-footer">
			<div class="w-table-content"
				 ref="content">
				<vxe-table ref="table"
						   align="center"
						   auto-resize
						   resizable
						   :data="tableObj.data"
						   default-expand-all
						   :loading="tableObj.loading"
						   :border="tableObj.border"
						   height="100%"
						   size="small"
						   highlight-current-row
						   highlight-hover-row
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   @current-change="rowClick">
					<vxe-table-column type="seq"
									  title="序号"
									  align="center"
									  width="70"></vxe-table-column>
					<vxe-table-column title="操作"
									  width="150">
						<template v-slot="{ row }">
							<div class="btnGroups">
								<el-button title="编辑"
										   size="small"
										   type="text"
										   :disabled="row.status == 1"
										   @click="tableBtnClick('edit', row)"
										   icon="el-icon-edit">
								</el-button>
								<el-button title="删除"
										   size="small"
										   type="text"
										   :disabled="row.status == 1"
										   icon="el-icon-delete"
										   @click="tableBtnClick('delete', row)">
								</el-button>
								<el-button title="复制"
										   size="small"
										   type="text"
										   icon="el-icon-copy-document"
										   @click="tableBtnClick('cope', row)">
								</el-button>
							</div>
						</template>
					</vxe-table-column>
					<vxe-table-column title="状态"
									  width="150">
						<template v-slot="{ row }">
							<vxe-switch v-model="row.status"
										open-label="启用"
										:open-value="1"
										close-label="禁用"
										:close-value="0"
										@change="tableBtnClick('change', row)"></vxe-switch>
						</template>
					</vxe-table-column>
					<vxe-table-column field="sname"
									  title="模板名称"
									  min-width="150">
						<template v-slot="{ row }">
							<span class="blue-text"
								  @click="tableBtnClick('view', row)">{{ row.sname }}</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="temTypeName"
									  title="工程类型"
									  min-width="150"></vxe-table-column>
				</vxe-table>
			</div>
			<div class="w-table-footer">
				<el-pagination :page-sizes="tableObj.pageList"
							   :page-size="tableObj.currentPage"
							   layout="total, sizes, prev, pager, next, jumper"
							   :total="tableObj.total"
							   @size-change="handleSizeChange"
							   @current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="dialogObj.visible = false">
			<!-- 弹窗组件 -->
			<el-form class="tableForm"
					 v-if="dialogObj.visible"
					 :model="objectForm"
					 :rules="formRules"
					 ref="objectForm"
					 :show-message="false"
					 label-width="140px">
				<el-form-item label="模板编号"
							  v-if="['edit','view','cope', 'add'].includes(dialogObj.mode)">
					<el-input v-model="objectForm.serialNo"
							  disabled
							  placeholder="系统自动生成"></el-input>
				</el-form-item>
				<el-form-item label="模板名称"
							  prop="sname"
							  v-if="['edit','view','cope', 'add'].includes(dialogObj.mode)">
					<el-input v-model="objectForm.sname"
							  maxlength="30"
							  show-word-limit
							  placeholder="请输入"
							  clearable
							  :disabled="dialogObj.mode === 'view'"></el-input>
				</el-form-item>
				<el-form-item label="工程类型"
							  prop="temType"
							  v-if="['edit','view', 'add'].includes(dialogObj.mode)">
					<el-select v-model="objectForm.temType"
							   placeholder="请选择"
							   clearable
							   :disabled="dialogObj.mode === 'view'">
						<el-option v-for="(item, index) of projectDict.gclx"
								   :key="'类型' + index"
								   :label="item.sname"
								   :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模板描述"
							  prop="remark"
							  v-if="['edit','view', 'add'].includes(dialogObj.mode)">
					<el-input type="textarea"
							  v-model="objectForm.remark"
							  resize="none"
							  maxlength="200"
							  show-word-limit
							  :autosize="{ minRows: 5 }"
							  placeholder="请输入"
							  :disabled="dialogObj.mode === 'view'"></el-input>

				</el-form-item>
				<el-form-item label="是否启用"
							  prop="status"
							  v-if="['edit','view', 'add'].includes(dialogObj.mode)">
					<vxe-switch v-model="objectForm.status"
								open-label="启用"
								:open-value="1"
								close-label="禁用"
								:close-value="0"
								:disabled="dialogObj.mode === 'view'"></vxe-switch>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave"
						   v-if="dialogObj.mode !== 'view'">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import {
	getProPages,
	saveTemPro,
	updateTemPro,
	copyTemPro,
} from '@/api/modules/structureType.js'
export default {
	name: '',
	components: {},
	data() {
		return {
			btnLoading: false,
			searchObj: {
				sname: '', //模板名称
				size: 10, //每页条数
				current: 1, //页数
				proTypeName: '', //适用项目类型
				formatName: '', //应用业态
			},
			dialogObj: {
				title: '', //弹框标题
				visible: false, //弹框是否显示
				width: '650px', //弹框宽度
				mode: 'add', //弹框模式 add:新增
			},

			//表格对象
			tableObj: {
				loading: false,
				data: [], //数据源
				currentPage: 1, //分页信息
				pageSize: 10,
				total: 0,
				border: true,
				pageList: [10, 20, 50, 100], // 显示条数数组
			},

			objectForm: {
				sname: '',
				serialNo: '',
				applyPro: '',
				temType: '', // 0单项级，1项目级
				remark: '',
				status: 1,
			},
			formRules: {
				sname: [{ required: true, trigger: 'blur' }],
				applyPro: [{ required: true, trigger: 'change' }],
				temType: [{ required: true, trigger: 'change' }],
				status: [{ required: true, trigger: 'change' }],
			},

			curRow: null,
		}
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
	},
	created() {
		this.getTableList()
	},
	methods: {
		//获取项目结构模板列表
		getTableList() {
			this.tableObj.loading = true
			let param = { ...this.searchObj }
			getProPages(param)
				.then((res) => {
					if (res.operationCode == 1) {
						let data = res.data.records
						data.map((item) => {
							item.formatName = item.formatName.replace(',', '>')
						})
						this.tableObj.data = data
						this.tableObj.total = parseInt(res.data.total)
						this.tableObj.pageSize = parseInt(res.data.size)
						this.$refs.table.setCurrentRow(this.tableObj.data[0])
						setTimeout(() => {
							this.tableObj.loading = false
						}, 1000)
						this.rowClick({ row: this.tableObj.data[0] })
					}
				})
				.finally(() => {
					this.tableObj.loading = false
				})
		},

		// 新增/修改
		doSave() {
			let that = this
			this.$refs['objectForm'].validate((valid) => {
				if (valid) {
					that.btnLoading = true
					if (this.dialogObj.mode == 'cope') {
						let params = {
							id: this.objectForm.id,
							sname: this.objectForm.sname,
						}
						copyTemPro(params)
							.then((res) => {
								if (res.operationCode == 1) {
									this.btnLoading = false
									this.dialogObj.visible = false
									this.getTableList()
								} else {
									setTimeout(() => {
										that.btnLoading = false
									}, 1000)
									this.$message({
										message: res.data,
										type: 'error',
									})
								}
							})
							.catch((err) => {
								setTimeout(() => {
									that.btnLoading = false
								}, 1000)
							})
						return
					}
					let param = Object.assign({}, this.objectForm)
					saveTemPro(param)
						.then((res) => {
							this.btnLoading = false
							if (res.operationCode == 1) {
								this.dialogObj.visible = false
								this.getTableList()
								if (this.dialogObj.mode == 'edit')
									this.$emit('success-callback')
							} else {
								that.btnLoading = false
								this.$message({
									message: res.data,
									type: 'error',
								})
							}
						})
						.catch((err) => {
							setTimeout(() => {
								that.btnLoading = false
							}, 1500)
						})
				} else {
					this.$message.warning('请先完善表单！')
					return false
				}
			})
		},

		tableBtnClick(type, row) {
			this.dialogObj.mode = type
			if (type == 'edit') {
				Object.keys(this.objectForm).forEach(
					(key) => (this.objectForm[key] = '')
				)
				this.dialogObj.title = '编辑'
				this.dialogObj.width = '1000px'
				this.dialogObj.visible = true
				this.objectForm = Object.assign({}, row)
			} else if (type == 'view') {
				Object.keys(this.objectForm).forEach(
					(key) => (this.objectForm[key] = '')
				)
				this.dialogObj.title = '查看模板'
				this.dialogObj.width = '1000px'
				this.objectForm = Object.assign({}, row)
				this.dialogObj.visible = true
			} else if (type == 'add') {
				Object.keys(this.objectForm).forEach(
					(key) => (this.objectForm[key] = '')
				)
				this.objectForm.status = 1
				this.dialogObj.title = '新增模板'
				this.dialogObj.width = '1000px'

				this.dialogObj.visible = true
			} else if (type == 'cope') {
				Object.keys(this.objectForm).forEach(
					(key) => (this.objectForm[key] = '')
				)
				this.dialogObj.title = '复制模板'
				this.dialogObj.width = '1000px'
				this.dialogObj.visible = true
				this.objectForm.id = row.id
			} else if (type == 'delete') {
				this.deleteById(row)
			} else if (type == 'change') {
				this.changeStatus(row)
			}
		},

		deleteById(row) {
			this.$confirm('该目录下有子事项，请先删除子事项！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				// let param = {
				// 	id: row.id
				// }
				// deleteById(param).then((res) => {
				// 	if (res.operationCode == 1) {
				// 		this.$message({ message: '删除成功', type: 'success' })
				// 		this.getTableList()
				// 		this.$emit('row-click', { id: '' })
				// 	}
				// })
			})
		},
		//启用/禁用
		changeStatus(row) {
			row.status = row.status ? 0 : 1
			this.$confirm(
				`确认${row.status ? '禁用' : '启用'}?该目录下所有事项都将${
					row.status ? '禁用' : '启用'
				}!`,
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			).then(() => {
				let status = row.status ? 0 : 1
				let param = {
					id: row.id,
					status,
				}
				updateTemPro(param).then((res) => {
					if (res.operationCode == 1) {
						this.$message({ message: '操作成功', type: 'success' })
						row.status = status
						// this.$emit('row-click', { id: '' })
					}
				})
			})
		},

		rowClick({ row }) {
			this.curRow = row
			this.$emit('row-click', row)
		},
		// 重置表单
		resetForm() {
			Object.keys(this.objectForm).forEach(
				(key) => (this.objectForm[key] = '')
			)
		},
		// 切换分页
		handlePageChange(page) {
			this.searchObj.current = page
			this.getTableList()
		},
		// 切换分页
		handleSizeChange(size) {
			this.searchObj.size = size
			this.getTableList()
		},
	},
}
</script>
<style lang="less" scoped>
.blue-text {
	cursor: pointer !important;
	color: #3ba1ff !important;
}
</style>
